import React from "react";

export const TriangleTop = () => {
	return (
		<svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path opacity="0.4" d="M7 1.39876e-06L13.9282 6.75L0.0717957 6.75L7 1.39876e-06Z" fill="white" />
		</svg>
	);
};
